import { render, staticRenderFns } from "./billClient.vue?vue&type=template&id=d2c3653e"
import script from "./billClient.vue?vue&type=script&lang=js"
export * from "./billClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports